import React from "react";
import { connect } from "react-redux";
import { Translate } from "react-redux-i18n";
import ReelCard from "./ReelCard";
import "./styles/ReelsCarousel.css";
import * as actions from "../redux/actions/reelActions";

class ReelsCarousel extends React.Component {
  componentDidMount() {
    if (this.props.token && this.props.user_id) {
      this.props.LoadList(this.props.user_id, this.props.token);
    }
  }

  render() {
    const { list } = this.props;

    if (!list.length) {
      return null;
    }

    return (
      <section className="reels-section">
        <header className="reels-section__header">
          <h2 className="reels-section__title">
            <Translate value="reels_title" />
          </h2>
          <p className="reels-section__subtitle">
            <Translate value="reels_subtitle" />
          </p>
        </header>

        <div className="reels-carousel">
          {list.map((item) => (
            <ReelCard key={item.Id} item={item} />
          ))}
        </div>
      </section>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    list: reducer.reel.list,
    loading: reducer.reel.loading,
    error: reducer.reel.error,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadList: (user_id, token) => dispatch(actions.loadList({ user_id, token })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReelsCarousel);
